<h1 mat-dialog-title>Still There?</h1>
<mat-dialog-content>Your session will expire in {{readableTimeLeft()}}.  Do you want to continue working?</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button [mat-dialog-close]="false" type="button">No, Logout</button>
	<button type="submit" [mat-dialog-close]="true" mat-raised-button color="primary">Yes, Continue</button>
</mat-dialog-actions>
